<template>
  <div>
    <component :is="view"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainMenuList from './MainMenuList.vue'
import PowerbuyMenuList from './PowerbuyMenuList.vue'
import KingKitchenMenu from './KingKitchenMenu.vue'

export default {
  components: {
    MainMenuList,
    PowerbuyMenuList,
    KingKitchenMenu
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['selectedBot']),
    view() {
      if (this.selectedBot.theme == 'powerbuy' || this.selectedBot.theme == 'powerby') {
        return 'PowerbuyMenuList'
      } else if (this.selectedBot.theme == 'kingkitchen') {
        return 'KingKitchenMenu'
      } else {
        return 'MainMenuList'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/layouts/MenuList/main.vue